import axios, { AxiosInstance } from 'axios';
import { HttpStatusCode } from 'constants/globals';
import { AUTH_SESSION_STORAGE_KEYS } from 'core/storage/authSessionStorage';
import service from 'service/auth';

export const createAuthRefreshInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({ baseURL });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error?.response?.status === HttpStatusCode.NotFound ||
        error?.response?.status === HttpStatusCode.Unauthorized
      ) {
        localStorage.removeItem(AUTH_SESSION_STORAGE_KEYS.apiToken);
        service.doLogout();
      }

      return Promise.reject(error);
    },
  );

  return instance;
};
